"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var event_info_1 = require("./event-info");
var extra_form_data_1 = require("./extra-form-data");
var uuid_1 = require("uuid");
var CommonEvent = /** @class */ (function () {
    function CommonEvent(_a) {
        var generateId = (_a === void 0 ? { generateId: true } : _a).generateId;
        this._id = generateId ? uuid_1.v4() : null;
        this.info = new event_info_1.EventInfo();
        this.extraFormData = new extra_form_data_1.ExtraFormData();
        this.cardFields = new Array();
        this.formFirst = true;
        this.allowFavorite = true;
        this.allowHeader = true;
        this.showInfoOnHeader = true;
        this.showHeaderImage = true;
        this.uniqueVoucher = true;
        this.uniquePrice = true;
    }
    CommonEvent.prototype.favorite = function () {
        this.extraFormData = this.extraFormData || {};
        this.extraFormData.favorited = !this.extraFormData.favorited;
        return this;
    };
    return CommonEvent;
}());
exports.CommonEvent = CommonEvent;
//# sourceMappingURL=common-event.js.map